import React from 'react';
import MyDocumentsSideNavLink from '../components/MyDocumentsSideNavLink';
import Constants from '../Constants';
import useDocumentSummary from './useDocumentSummary';

const useDocumentsNavLinks = () => {
  const { isVisible } = useDocumentSummary();
  return isVisible ? [<MyDocumentsSideNavLink key="MyDocuments" path={Constants.BasePagePath} />] : [];
};

export default useDocumentsNavLinks;
